import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/shared/shared.service';
import {AbstractControl, AsyncValidatorFn, FormControl, ValidatorFn, Validators} from '@angular/forms';
import {UpdateContact} from '../../profile/contact-info/contact-info.component';
import {ProfileService} from '../../profile/profile.service';
import {LoggerService} from '../../logger/logger.service';
import {MatDialog} from '@angular/material';
import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'app-congrats',
  templateUrl: './congrats.component.html',
  styleUrls: ['./congrats.component.css']
})
export class CongratsComponent implements OnInit {
  private EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public is_loading: boolean;
  public email_verified = false;
  public email: string;
  public email_verification_required = false;
  emailFormControl = new FormControl('', [
    Validators.pattern(this.EMAIL_REGEX)
  ]);
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService
  ) {
    this.is_loading = true;
    sharedService.setLoader('congrats', true);
    sharedService.setHeaderTitle('congrats');

    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then((res) => {
          this.is_loading = false;
          sharedService.setLoader('congrats', false);
          if (res.status === 'success' && res.isTerminated === false) {
            const person = res.results[0]['personal'][0];
            const dataLayerEvent = 'enroll - success';
            this.email_verified = person.isEmailVerify === 1;
            this.email_verification_required = person.requiresEmailValidation;
            (window as any).dataLayer.push(
              { 'event': dataLayerEvent,
                'accountID': person.id.toString(),
                'accountNumber': person.accountNumber.toString()
              });
            sharedService.setHeaderUserLoggedIn('congrats', true, person);
            sharedService.setHeaderTitle('congrats');
          } else {
            this.localStorageService.remove('token');
            this.router.navigate(['./enroll']);
          }
        });
    }
    else {
      this.router.navigate(['./enroll']);
    }

  }

  ngOnInit() {
  }

  gotoDashboard() {
    this.localStorageService.set('last_skip_date', new Date());
    this.localStorageService.set('skip_otp', true);
    this.router.navigate(['./dashboard']);
  }

  updateEmailVerified(verified: boolean) {
    this.email_verified = verified;
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/congrats/congrats.component.ts